exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".proComponent[data-v-14f4fafe]{border-collapse:collapse;width:100%}.proComponent th[data-v-14f4fafe]{padding:0 5px}.proComponent td[data-v-14f4fafe],.proComponent th[data-v-14f4fafe]{border:1px solid #ccc;line-height:50px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-14f4fafe","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/project_info/operation_activities/step_forms/projectComponents.vue
// module id = 1130
// module chunks = 3